"use client";

// Components
import {
  HomepageSlider,
  HomepageSliderSkeleton,
  PopularCategories,
} from "@workspace/ui/widgets";
import React, { Suspense } from "react";

import { useCustomer, useGlobal } from "@/context";
import { NewsletterForm, NewsletterFormSkeleton } from "@/forms";

export default function Home() {
  const {
    state: {
      homepageImageSlider,
      popularCategories,
      loadingHomepage,
      getResponseDataChecked,
      getResponseData,
    },
  } = useGlobal();

  const {
    state: { isLoggedIn },
  } = useCustomer();

  return (
    <div className="max-w-screen-2xl mx-auto">
      <Suspense fallback={<HomepageSliderSkeleton />}>
        <HomepageSlider
          slides={homepageImageSlider.index || []}
          isLoading={loadingHomepage}
        />
      </Suspense>

      <Suspense fallback={<NewsletterFormSkeleton />}>
        {isLoggedIn && !getResponseDataChecked && <NewsletterFormSkeleton />}
        {!isLoggedIn && <NewsletterForm />}
        {isLoggedIn &&
          getResponseDataChecked &&
          (!getResponseData?.subscribed || getResponseData?.unconfirmed) && (
            <NewsletterForm unconfirmed={getResponseData?.unconfirmed} />
          )}
      </Suspense>

      <PopularCategories
        popularCategories={popularCategories || []}
        selectedPage="/"
        isLoading={loadingHomepage}
      />
    </div>
  );
}
